import styled from 'styled-components'
import { Classes, Colors } from '@blueprintjs/core'

import { boxCss, BoxProps } from './box'
import { quarks } from '.'

export type TextProps = BoxProps & {
  small?: boolean
  large?: boolean
  muted?: boolean
  running?: boolean
  disabled?: boolean
  ellipsis?: boolean
  monospace?: boolean
  interactive?: boolean
  isLoading?: boolean
  caption?: boolean
}

const Text = styled.span.withConfig({
  shouldForwardProp: (prop) =>
    ![
      "small",
      "large",
      "muted",
      "running",
      "disabled",
      "ellipsis",
      "monospace",
      "interactive",
      "isLoading",
      "caption",
    ].includes(prop),
}).attrs<TextProps, TextProps>(
  ({
    small,
    large,
    muted,
    running,
    disabled,
    ellipsis,
    monospace,
    isLoading,
  }) => ({
    className: Object.entries({
      [Classes.TEXT_SMALL]: small,
      [Classes.TEXT_LARGE]: large,
      [Classes.TEXT_MUTED]: muted,
      [Classes.RUNNING_TEXT]: running,
      [Classes.TEXT_DISABLED]: disabled,
      [Classes.TEXT_OVERFLOW_ELLIPSIS]: ellipsis,
      [Classes.MONOSPACE_TEXT]: monospace,
      [Classes.SKELETON]: isLoading,
    })
      .filter(([_, val]) => !!val)
      .map(([key, _]) => key)
      .join(' '),
  }),
)`
  ${(p) =>
    p.interactive &&
    `
    cursor: pointer;
    color: ${Colors.BLUE5};
    &:hover {
      color: ${Colors.BLUE3};
    }
  `}
  ${(p) =>
    p.caption &&
    `
    font-size: ${quarks.fontSizes.xsmall};
    font-weight: ${quarks.fontWeights.bold};
    text-transform: uppercase;
  `}
  ${boxCss}
`

export default Text
